import type { AwardFormSchema } from '../schemas';

export const defaultValues: Readonly<AwardFormSchema> = {
  id: -1,
  name: '',
  award_month: null,
  award_year: null,
  sponsoring_organization: '',
  award_type: null,
  notes: '',
  brand: null,
  client: null,
  gallery: [],
};
